// extracted by mini-css-extract-plugin
export default {"enterSMSCode":"style_enterSMSCode__-cu4L"};